import * as types from '../mutation-types'

const state = {
  reloadZy: 0,
  reloadYx: 0,
  reloadKc: 0,
  reloadFee: 0,
  reloadFeetag: 0,
  reloadFeeout: 0,
  reloadSfbz: 0,
  reloadBase: 0,
  reloadStu: 0,
  reloadRoll: 0,
  reloadClass: 0,
  reloadClassRoll: 0,
  reloadRollChange: 0,
  reloadScore: 0,
  reloadExport: 0,
  reloadPxinfo: 0,
  reloadSealtype: 0,
  reloadSeal: 0,
  reloadContract: 0,
  reloadGoods: 0,
  reloadJilu: 0,
  reloadHuiyishi: 0,
  reloadNotify: 0,
  reloadNotice: 0,
  reloadNews: 0,
  reloadInfo: 0,
  reloadKp: 0,
  reloadOrder: 0,
  reloadWebUser: 0,
  reloadAddress: 0,
  reloadSite: 0,
  reloadDepart: 0,
  reloadEmp: 0,
  reloadComment: 0,
  reloadWeb: 0,
}

const getters = {
  [types.OTHER.reloadZy]: (state) => {
    return state.reloadZy;
  },
  [types.OTHER.reloadYx]: (state) => {
    return state.reloadYx;
  },
  [types.OTHER.reloadKc]: (state) => {
    return state.reloadKc;
  },
  [types.OTHER.reloadFee]: (state) => {
    return state.reloadFee;
  },
  [types.OTHER.reloadFeetag]: (state) => {
    return state.reloadFeetag;
  },
  [types.OTHER.reloadFeeout]: (state) => {
    return state.reloadFeeout;
  },
  [types.OTHER.reloadSfbz]: (state) => {
    return state.reloadSfbz;
  },
  [types.OTHER.reloadBase]: (state) => {
    return state.reloadBase;
  },
  [types.OTHER.reloadStu]: (state) => {
    return state.reloadStu;
  },
  [types.OTHER.reloadRoll]: (state) => {
    return state.reloadRoll;
  },
  [types.OTHER.reloadClass]: (state) => {
    return state.reloadClass;
  },
  [types.OTHER.reloadClassRoll]: (state) => {
    return state.reloadClassRoll;
  },
  [types.OTHER.reloadRollChange]: (state) => {
    return state.reloadRollChange;
  },
  [types.OTHER.reloadScore]: (state) => {
    return state.reloadScore;
  },
  [types.OTHER.reloadExport]: (state) => {
    return state.reloadExport;
  },
  [types.OTHER.reloadPxinfo]: (state) => {
    return state.reloadPxinfo;
  },
  [types.OTHER.reloadSealtype]: (state) => {
    return state.reloadSealtype;
  },
  [types.OTHER.reloadSeal]: (state) => {
    return state.reloadSeal;
  },
  [types.OTHER.reloadContract]: (state) => {
    return state.reloadContract;
  },
  [types.OTHER.reloadGoods]: (state) => {
    return state.reloadGoods;
  },
  [types.OTHER.reloadJilu]: (state) => {
    return state.reloadJilu;
  },
  [types.OTHER.reloadHuiyishi]: (state) => {
    return state.reloadHuiyishi;
  },
  [types.OTHER.reloadNotify]: (state) => {
    return state.reloadNotify;
  },
  [types.OTHER.reloadNotice]: (state) => {
    return state.reloadNotice;
  },
  [types.OTHER.reloadNews]: (state) => {
    return state.reloadNews;
  },
  [types.OTHER.reloadInfo]: (state) => {
    return state.reloadInfo;
  },
  [types.OTHER.reloadKp]: (state) => {
    return state.reloadKp;
  },
  [types.OTHER.reloadOrder]: (state) => {
    return state.reloadOrder;
  },
  [types.OTHER.reloadWebUser]: (state) => {
    return state.reloadWebUser;
  },
  [types.OTHER.reloadAddress]: (state) => {
    return state.reloadAddress;
  },
  [types.OTHER.reloadSite]: (state) => {
    return state.reloadSite;
  },
  [types.OTHER.reloadDepart]: (state) => {
    return state.reloadDepart;
  },
  [types.OTHER.reloadEmp]: (state) => {
    return state.reloadEmp;
  },
  [types.OTHER.reloadComment]: (state) => {
    return state.reloadComment;
  },
  [types.OTHER.reloadWeb]: (state) => {
    return state.reloadWeb;
  },
}

const mutations = {
  [types.OTHER.reloadZy] (state) {
    state.reloadZy = Date.now();
  },
  [types.OTHER.reloadYx] (state) {
    state.reloadYx = Date.now();
  },
  [types.OTHER.reloadKc] (state) {
    state.reloadKc = Date.now();
  },
  [types.OTHER.reloadFee] (state) {
    state.reloadFee = Date.now();
  },
  [types.OTHER.reloadFeetag] (state) {
    state.reloadFeetag = Date.now();
  },
  [types.OTHER.reloadFeeout] (state) {
    state.reloadFeeout = Date.now();
  },
  [types.OTHER.reloadSfbz] (state) {
    state.reloadSfbz = Date.now();
  },
  [types.OTHER.reloadBase] (state) {
    state.reloadBase = Date.now();
  },
  [types.OTHER.reloadStu] (state) {
    state.reloadStu = Date.now();
  },
  [types.OTHER.reloadRoll] (state) {
    state.reloadRoll = Date.now();
  },
  [types.OTHER.reloadClass] (state) {
    state.reloadClass = Date.now();
  },
  [types.OTHER.reloadClassRoll] (state) {
    state.reloadClassRoll = Date.now();
  },
  [types.OTHER.reloadRollChange] (state) {
    state.reloadRollChange = Date.now();
  },
  [types.OTHER.reloadScore] (state) {
    state.reloadScore = Date.now();
  },
  [types.OTHER.reloadExport] (state) {
    state.reloadExport = Date.now();
  },
  [types.OTHER.reloadPxinfo] (state) {
    state.reloadPxinfo = Date.now();
  },
  [types.OTHER.reloadSealtype] (state) {
    state.reloadSealtype = Date.now();
  },
  [types.OTHER.reloadSeal] (state) {
    state.reloadSeal = Date.now();
  },
  [types.OTHER.reloadContract] (state) {
    state.reloadContract = Date.now();
  },
  [types.OTHER.reloadGoods] (state) {
    state.reloadGoods = Date.now();
  },
  [types.OTHER.reloadJilu] (state) {
    state.reloadJilu = Date.now();
  },
  [types.OTHER.reloadHuiyishi] (state) {
    state.reloadHuiyishi = Date.now();
  },
  [types.OTHER.reloadNotify] (state) {
    state.reloadNotify = Date.now();
  },
  [types.OTHER.reloadNotice] (state) {
    state.reloadNotice = Date.now();
  },
  [types.OTHER.reloadNews] (state) {
    state.reloadNews = Date.now();
  },
  [types.OTHER.reloadInfo] (state) {
    state.reloadInfo = Date.now();
  },
  [types.OTHER.reloadPoint] (state) {
    state.reloadPoint = Date.now();
  },
  [types.OTHER.reloadKp] (state) {
    state.reloadKp = Date.now();
  },
  [types.OTHER.reloadOrder] (state) {
    state.reloadOrder = Date.now();
  },
  [types.OTHER.reloadWebUser] (state) {
    state.reloadWebUser = Date.now();
  },
  [types.OTHER.reloadAddress] (state) {
    state.reloadAddress = Date.now();
  },
  [types.OTHER.reloadSite] (state) {
    state.reloadSite = Date.now();
  },
  [types.OTHER.reloadDepart] (state) {
    state.reloadDepart = Date.now();
  },
  [types.OTHER.reloadEmp] (state) {
    state.reloadEmp = Date.now();
  },
  [types.OTHER.reloadComment] (state) {
    state.reloadComment = Date.now();
  },
  [types.OTHER.reloadWeb] (state) {
    state.reloadWeb = Date.now();
  },
}

export default {
  state,
  getters,
  mutations
}
